import { Menu } from "@material-ui/core";
import { useMenuStyles } from "../../TopMenu/components/StyledMenu";
export const HelpMenu = ({ children, anchorEl, onClose, }) => {
    const { list: menuList } = useMenuStyles();
    return (<Menu keepMounted anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose} MenuListProps={{ className: menuList }} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} transformOrigin={{ vertical: "top", horizontal: "center" }} getContentAnchorEl={null}>
      {children}
    </Menu>);
};
